import React, { useState } from 'react';
import { Mail, ArrowLeft, Sparkles, Check } from 'lucide-react';
import { RouteConstant } from '../../routes/RouteConstant';
import { useNavigate } from 'react-router-dom';
import authQueries from '../../queries/authQueries';

const ForgotPassword = () => {

    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate()

    const forgotPassword = authQueries.useForgotPassword(
        (res)=>{
            setIsLoading(false);
            setIsSubmitted(true);
        }
    )

    const handleSubmit = async () => {
        setIsLoading(true);

        await forgotPassword.mutateAsync({
            email
        })
        
        setTimeout(() => {
        }, 2000);
    };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 flex items-center justify-center p-4 relative overflow-hidden">

      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-purple-300/20 to-pink-300/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-blue-300/20 to-purple-300/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-gradient-to-br from-pink-300/10 to-purple-300/10 rounded-full blur-2xl animate-bounce delay-500"></div>
      </div>

      <div className="relative w-full max-w-md">
        <div className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-8 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 via-transparent to-pink-500/5 pointer-events-none"></div>
          
          <button
          onClick={()=> navigate(-1)}
          className="absolute top-6 left-6 p-2 rounded-full bg-gray-100/50 hover:bg-gray-200/50 transition-all duration-200 group">
            <ArrowLeft className="w-5 h-5 text-gray-600 group-hover:text-gray-800 transition-colors" />
          </button>

          {!isSubmitted ? (
            <>
                <div className="flex justify-center mb-8 pt-8">
                    <div className="relative">
                    <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center shadow-lg">
                        <Mail className="w-10 h-10 text-white" />
                    </div>
                    <div className="absolute -top-2 -right-2">
                        <Sparkles className="w-6 h-6 text-yellow-400 animate-pulse" />
                    </div>
                    </div>
                </div>

                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-3">
                    Forgot Password?
                    </h1>
                    <p className="text-gray-600 text-sm leading-relaxed">
                    No worries! Enter your email address and we'll send you a temporary password
                    </p>
                </div>

                <div className="space-y-6">
                    <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Email Address
                    </label>
                    <div className="relative">
                        <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full px-4 py-4 pl-12 bg-gray-50/50 border border-gray-200/50 rounded-2xl focus:outline-none focus:ring-2 focus:ring-purple-500/20 focus:border-purple-400 transition-all duration-200 text-gray-800 placeholder-gray-400"
                        placeholder="Enter your email"
                        />
                        <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                    </div>
                    </div>

                    <button
                    onClick={handleSubmit}
                    disabled={isLoading}
                    className="w-full py-4 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold rounded-2xl transition-all duration-200 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-purple-500/20 disabled:opacity-70 disabled:cursor-not-allowed shadow-lg"
                    >
                    {isLoading ? (
                        <div className="flex items-center justify-center space-x-2">
                        <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                        <span>Sending...</span>
                        </div>
                    ) : (
                        'Send Reset Link'
                    )}
                    </button>
                </div>

                <div className="text-center mt-8">
                    <p className="text-gray-500 text-sm">
                    Remember your password?{' '}
                    <button onClick={()=> navigate(RouteConstant.LOGIN)} className="text-purple-600 hover:text-purple-700 font-medium transition-colors">
                        Sign In
                    </button>
                    </p>
                </div>
            </>
          ) : (
            <>

              <div className="text-center py-4">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center mx-auto mb-6 shadow-lg">
                  <Check className="w-10 h-10 text-white" />
                </div>
                
                <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-4">
                  Check Your Email
                </h1>
                
                <p className="text-gray-600 text-sm leading-relaxed mb-8">
                  We've sent a password reset link to<br />
                  <span className="font-medium text-purple-600">{email}</span>
                </p>

                <button
                onClick={() => navigate(RouteConstant.LOGIN)}
                className="w-full py-4 bg-gradient-to-r from-gray-100 to-gray-200 hover:from-gray-200 hover:to-gray-300 text-gray-700 font-semibold rounded-2xl transition-all duration-200 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-gray-300/50"
                >
                  Back to Login
                </button>
              </div>
            </>
          )}
        </div>

        <div className="text-center mt-8">
          <p className="text-gray-400 text-xs">
            Secured with end-to-end encryption
          </p>
        </div>

      </div>
    </div>
  );
};

export default ForgotPassword;